export const floatingLabels = {
  id: "floatingLabels",
  afterDatasetsDraw(chart) {
    if (chart.canvas.id == "my-chart-bar-percentage") {
      // console.log(chart);
      chart.ctx.save();

      const datasetArray = chart.data.datasets[0].data.map(
        (datapoint, index) => {
          if (datapoint > chart.data.datasets[1].data[index]) {
            return 0;
          } else {
            return 1;
          }
        }
      );

      const percentageArray = [
        "18,2%",
        "20,8%",
        "12%",
        "5,2%",
        "1,1%",
        "0,6%",
        "39,8%",
      ];

      //  console.log(diffArray)

      datasetArray.forEach((value, index) => {
        chart.ctx.font = "bold 14px sans-serif";
        chart.ctx.fillStyle = "#666";
        chart.ctx.texAlign = "center";
        chart.ctx.fillText(
          percentageArray[index],
          chart.scales.x.getPixelForValue(index) - 15,
          chart.getDatasetMeta(datasetArray[index]).data[index].y - 10
        );
      });
    }
  },
};
